module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-attachment-579d2512e6bb53e1105fbd19832a95d4.svg";